import * as yup from "yup";

export const yupPattern = yup
  .object({
    pattern: yup.string().required(),
  })
  .required();
